/**
 * Whether the user completing the onboarding already belongs to the publisher
 * (company) side of the product.
 *
 * Read once, from the pre-mutation session state, to pick the post-submit
 * path: publishers keep the historical toast + automatic redirect, pure
 * freelancers get the profile-building celebration instead.
 */
export const isPublisherAtSubmit = (
  auth: {
    capabilities?: { can_publish: boolean } | null;
    companies?: unknown[] | null;
  } | null,
): boolean =>
  Boolean(auth?.capabilities?.can_publish) ||
  (auth?.companies ?? []).length > 0;
